import { createMOPSuccess } from '../PaymentState.actions';
import { setSelectedMop, updateMopList } from '../../MopOnFileState/MopOnFileState.actions';
import { updateDescription, updatePaymentMethodsData } from '../../MopOnFileState/MopOnFileState.helpers';
import { setAppMode } from '../../AppModeState/AppModeState.actions';
import { AppMode } from '../../AppModeState/AppModeState.types';
import { transformMopResponseData } from './transformMopResponseData';
/**
 * handleUpdateMopSuccess handles success from update mop API
 */
export var handleUpdateMopSuccess = function handleUpdateMopSuccess(params) {
  var _rawData;
  var response = params.response,
    dispatch = params.dispatch,
    goBackMode = params.goBackMode,
    state = params.state,
    paymentForm = params.paymentForm;
  var payload = transformMopResponseData(response);
  dispatch(createMOPSuccess(payload));
  var updatedMop = updateDescription((_rawData = payload.rawData) === null || _rawData === void 0 ? void 0 : _rawData.mopV2, paymentForm);
  var updatedMopList = updatePaymentMethodsData(state.mopOnFile.paymentMethods, updatedMop);
  dispatch(updateMopList({
    paymentMethods: updatedMopList
  }));
  dispatch(setSelectedMop({
    mop: updatedMop
  }));
  dispatch(setAppMode({
    mode: goBackMode,
    goBackMode: AppMode.EDIT
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/helpers/handleUpdateMopSuccess.js
// module id = 4400
// module chunks = 11